import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";

const PaywallRoute = ({ children }) => {
  const [isPaidUser, setIsPaidUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const session = await fetchAuthSession();

        const groups =
          session.tokens?.idToken?.payload?.["cognito:groups"] ||
          session.tokens?.accessToken?.payload?.["cognito:groups"] ||
          [];

        setIsPaidUser(groups.includes("Paywall"));
      } catch (e) {
        setIsPaidUser(false);
      }
    };

    checkUser();
  }, []);

  // ⏳ loading state (avoid flicker)
  if (isPaidUser === null) return null;

  // ❌ not paid → redirect
  if (!isPaidUser) {
    return <Navigate to="/glue-dashboard" replace />;
  }

  // ✅ paid → allow
  return children;
};

export default PaywallRoute;